import { useEffect, useState } from 'react';

interface UseHighlightPulseArgs {
  isHighlighted: boolean;
  highlightWatchedValue?: string | number;
}

export const useHighlightPulse = ({
  isHighlighted,
  highlightWatchedValue,
}: UseHighlightPulseArgs): boolean => {
  const [isHighlightPulseRunning, setIsHighlightPulseRunning] = useState(false);

  useEffect(() => {
    if (!isHighlighted) {
      setIsHighlightPulseRunning(false);

      return undefined;
    }

    setIsHighlightPulseRunning(false);

    const animationFrame = requestAnimationFrame(() =>
      setIsHighlightPulseRunning(true),
    );

    return () => cancelAnimationFrame(animationFrame);
  }, [isHighlighted, highlightWatchedValue]);

  return isHighlightPulseRunning;
};
